import { apiClient } from './apiClient';

const asList = (data) => data?.results || data || [];

export const otcService = {
  listar: async (params = {}) => {
    const response = await apiClient.get('/ordenes-trabajo-correctivas/', { params });
    return response.data;
  },

  obtener: async (id) => {
    const response = await apiClient.get(`/ordenes-trabajo-correctivas/${id}/`);
    return response.data;
  },

  crear: async (payload) => {
    const response = await apiClient.post('/ordenes-trabajo-correctivas/', payload);
    return response.data;
  },

  actualizar: async (id, payload) => {
    const response = await apiClient.put(`/ordenes-trabajo-correctivas/${id}/`, payload);
    return response.data;
  },

  eliminar: async (id) => {
    await apiClient.delete(`/ordenes-trabajo-correctivas/${id}/`);
  },

  cerrar: async (id, payload = {}) => {
    const response = await apiClient.post(`/ordenes-trabajo-correctivas/${id}/cerrar/`, payload);
    return response.data;
  },

  cancelar: async (id, payload = {}) => {
    const response = await apiClient.post(`/ordenes-trabajo-correctivas/${id}/cancelar/`, payload);
    return response.data;
  },

  listarTareas: async (params = {}) => {
    const response = await apiClient.get('/otc-tareas/', { params });
    return asList(response.data);
  },

  crearTarea: async (payload) => {
    const response = await apiClient.post('/otc-tareas/', payload);
    return response.data;
  },

  actualizarTarea: async (id, payload) => {
    const response = await apiClient.put(`/otc-tareas/${id}/`, payload);
    return response.data;
  },

  eliminarTarea: async (id) => {
    await apiClient.delete(`/otc-tareas/${id}/`);
  },

  listarRepuestos: async (params = {}) => {
    const response = await apiClient.get('/otc-repuestos/', { params });
    return asList(response.data);
  },

  crearRepuesto: async (payload) => {
    const response = await apiClient.post('/otc-repuestos/', payload);
    return response.data;
  },

  actualizarRepuesto: async (id, payload) => {
    const response = await apiClient.put(`/otc-repuestos/${id}/`, payload);
    return response.data;
  },

  eliminarRepuesto: async (id) => {
    await apiClient.delete(`/otc-repuestos/${id}/`);
  },

  // Mecánicos
  listarMecanicos: async (params = {}) => {
    const response = await apiClient.get('/otc-mecanicos/', { params });
    return asList(response.data);
  },

  crearMecanico: async (payload) => {
    const response = await apiClient.post('/otc-mecanicos/', payload);
    return response.data;
  },

  actualizarMecanico: async (id, payload) => {
    const response = await apiClient.put(`/otc-mecanicos/${id}/`, payload);
    return response.data;
  },

  eliminarMecanico: async (id) => {
    await apiClient.delete(`/otc-mecanicos/${id}/`);
  },

  // Gastos extra
  listarGastosExtra: async (params = {}) => {
    const response = await apiClient.get('/otc-gastos-extra/', { params });
    return asList(response.data);
  },

  crearGastoExtra: async (payload) => {
    const response = await apiClient.post('/otc-gastos-extra/', payload);
    return response.data;
  },

  actualizarGastoExtra: async (id, payload) => {
    const response = await apiClient.put(`/otc-gastos-extra/${id}/`, payload);
    return response.data;
  },

  eliminarGastoExtra: async (id) => {
    await apiClient.delete(`/otc-gastos-extra/${id}/`);
  },

  // Adjuntos
  subirAdjunto: async (otcId, formData) => {
    const response = await apiClient.post(`/ordenes-trabajo-correctivas/${otcId}/adjuntar/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  eliminarAdjunto: async (otcId, adjuntoId) => {
    await apiClient.delete(`/ordenes-trabajo-correctivas/${otcId}/adjuntos/${adjuntoId}/`);
  },

  editarAdjunto: async (otcId, adjuntoId, formData) => {
    const response = await apiClient.patch(`/ordenes-trabajo-correctivas/${otcId}/adjuntos/${adjuntoId}/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
};

export default otcService;
